import { useQuery } from "react-query";

import { useOrg, useTimeLookbackRange } from "@hooks";

import { fetchProjectStats } from "../api";

export const useProjectStats = (reposFilter: string[]) => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();

  return useQuery(
    ["ProjectStats", org, tlr, reposFilter],
    () => fetchProjectStats(org!.id, tlr, reposFilter),
    {
      enabled: !!org,
    }
  );
};
